import React, { useEffect, useState } from 'react';
import axios from 'axios';
import Swal from 'sweetalert2';
import config from '../../config';
import { headers } from '../../token';
import vAdminformat from '../../adminFormat';
import validateError from '../../ValidateError';

const server_backend = config.API_URL;

function UpdateBussinessFile({ username, onBussinessFileID, onClose, getBussinessLibrary }) {
    const [loading, setLoading] = useState(false);
    const [userCreated, setUserCreated] = useState("");
    const [userModify, setUserModify] = useState("");
    const [dateCreated, setDateCreated] = useState("");
    const [dateModify, setDateModify] = useState("");
    const [fileExt, setFileExt] = useState("");

    let user2;
    try {
        user2 = JSON.parse(username);
    } catch (e) {
        user2 = username;
    }

    const [formData, setFormData] = useState({
        name: '',
        user_transaction: user2,
        id: ''
    });

    useEffect(() => {
        const getBussinessFile = async () => {
            try {
                const response = await axios.get(`${server_backend}/files/private/select?id=${onBussinessFileID}`, headers);
                if (response.data.RES_CODE === "00") {
                    const data = response.data.RES_RESULT[0];
                    setUserCreated(data.user_created);
                    setUserModify(data.user_modify);
                    setDateCreated(data.date_created);
                    setDateModify(data.date_modify);



                    const ext = data.name.includes('.') ? data.name.substring(data.name.lastIndexOf('.') + 1) : '';
                    setFileExt(ext);

      

                    const nameWithoutExt = ext ? data.name.substring(0, data.name.lastIndexOf('.')) : data.name;

                    setFormData({
                        name: nameWithoutExt,
                        comment: data.comment,
                        user_transaction: username,
                        est_id: data.est_ID,
                        id: onBussinessFileID
                    });
                }
            } catch (error) {
                console.log("Unexpected error, please check")
            }
        };
        getBussinessFile();
    }, [onBussinessFileID, username]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({
            ...formData,
            [name]: value
        });
    };

    const handleUpdate = async (e) => {
        e.preventDefault();
        setLoading(true);
        try {
            // Combine name + extension before sending

            const updatedData = {
                ...formData,
                name: fileExt ? `${formData.name}.${fileExt}` : formData.name
            };

            const response = await axios.post(`${server_backend}/files/private/update`, updatedData, headers);
            if (response.data.RES_CODE === "00") {
                Swal.fire({
                    icon: 'success',
                    title: 'Updated Successfully',
                    showConfirmButton: false,
                    timer: 1000
                });
                onClose();
                getBussinessLibrary();
            } else {
                Swal.fire({
                    icon: 'error',
                    title: 'There is already a file with the same name, please try with another name',
                    showConfirmButton: false,
                    timer: 2000
                });
            }
        } catch (error) {
            const message = validateError(error);
            Swal.fire({
                icon: 'error',
                title: message,
                showConfirmButton: false,
                timer: 2000
            });
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="modal fade show d-block" tabIndex="-1" style={{ backgroundColor: "#0101019e" }}>
            <div className="modal-dialog modal-xl">
                <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title">Modify Business File</h5>
                        <button type="button" className="btn-close" onClick={onClose}></button>
                    </div>
                    <div className="modal-body">
                        <form onSubmit={handleUpdate}>
                            <div className="row mb-3">
                                <div className="col-md-12">
                                    <label className="form-label">New File Name</label>
                                    <div className="input-group">
                                        <input
                                            type="text"
                                            className="form-control"
                                            placeholder="Enter new file name"
                                            name="name"
                                            value={formData.name}
                                            onChange={handleChange}
                                            required
                                        />
                                        {fileExt && (
                                            <span className="input-group-text bg-light text-muted">{fileExt}</span>
                                        )}
                                    </div>
                                    <small className="form-text text-muted">The file extension cannot be changed.</small>
                                </div>
                            </div>

                            <h4 className="mt-4">Other Information</h4>
                            <div className="row g-3">
                                <div className="col-md-6">
                                    <label className="form-label">Date Created</label>
                                    <input type="text" className="form-control" value={vAdminformat.FormatDate(dateCreated)} disabled />
                                </div>
                                <div className="col-md-6">
                                    <label className="form-label">User Created</label>
                                    <input type="text" className="form-control" value={userCreated} disabled />
                                </div>
                                <div className="col-md-6">
                                    <label className="form-label">Date Modified</label>
                                    <input type="text" className="form-control" value={dateModify && vAdminformat.FormatDate(dateModify)} disabled />
                                </div>
                                <div className="col-md-6">
                                    <label className="form-label">User Modified</label>
                                    <input type="text" className="form-control" value={userModify} disabled />
                                </div>
                            </div>

                            <div className="mt-4 text-end">
                                <button type="button" className="btn btn-danger me-2" onClick={onClose}>Discard changes</button>
                                <button type="submit" className="btn btn-primary" disabled={loading}>
                                    {loading ? (
                                        <>
                                            <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                                            Updating...
                                        </>
                                    ) : (
                                        'Submit'
                                    )}
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default UpdateBussinessFile;
